export interface OrganizationContactData {
    state?: string;
    invitationType?: string;
    contactRole?: string;
}

export interface SearchedOrganization {
    id: number;
    name?: string;
    gln?: string;
    address?: string;
    email?: string;
    hasImage?: boolean;
    matchingInviteeDataModel?: boolean;
    contactData?: OrganizationContactData;
}

export interface CommunityOption {
    id: number;
    name?: string;
}

const DEFAULT_COMMUNITY_NAME = '__DEFAULT_COMMUNITY__';

export function organizationSearchRequest(hash: string): 'community' | 'search' | undefined {
    const value = hash.replace(/^#/, '').replace(/^\//, '');
    if (value === 'community' || value === 'search') {
        return value;
    }
    return undefined;
}

export function memberCommunities(communities: CommunityOption[]): CommunityOption[] {
    return communities.filter((community) => community.name !== DEFAULT_COMMUNITY_NAME);
}

export function communityLabel(community: CommunityOption): string {
    return community.name || String(community.id);
}

/**
 * Invite is available for a community manager, or while searching inside a
 * community, when the organization has no contact or that contact was rejected.
 */
export function canInviteOrganization(input: {
    communityManager: boolean;
    communityScoped: boolean;
    contact?: OrganizationContactData;
}): boolean {
    if (!input.communityManager && !input.communityScoped) {
        return false;
    }
    if (input.contact == null) {
        return true;
    }
    return input.contact.state === 'REJECTED';
}

/**
 * Delete is available for a community manager when the contact was invited
 * as a buyer or a supplier.
 */
export function canDeleteSearchedOrganization(
    communityManager: boolean,
    invitationType?: string,
): boolean {
    return communityManager
        && (invitationType === 'INVITED_BUYER' || invitationType === 'INVITED_SUPPLIER');
}
